module.exports = __webpack_public_path__ + "static/media/logoWhite.9a4c15ed.png";